import { SIGNATURE_LIMITS } from '@demandproai/shared';

const formatDimensionsError = () =>
  `Image dimensions must be between ${SIGNATURE_LIMITS.MIN_WIDTH_PX}x${SIGNATURE_LIMITS.MIN_HEIGHT_PX} ` +
  `and ${SIGNATURE_LIMITS.MAX_WIDTH_PX}x${SIGNATURE_LIMITS.MAX_HEIGHT_PX} pixels.`;

const loadImageDimensions = (file) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    URL.revokeObjectURL(url);
    resolve({ width: img.naturalWidth, height: img.naturalHeight });
  };
  img.onerror = () => {
    URL.revokeObjectURL(url);
    reject(new Error('Failed to read image dimensions.'));
  };
  img.src = url;
});

export const validateSignatureFile = async ({ file }) => {
  if (file?.type !== SIGNATURE_LIMITS.MIME_TYPE) {
    return { isValid: false, error: 'File must be a valid PNG image.' };
  }
  if (file.size > SIGNATURE_LIMITS.MAX_FILE_SIZE_BYTES) {
    return { isValid: false, error: 'File exceeds the maximum size of 2 MB.' };
  }
  try {
    const { width, height } = await loadImageDimensions(file);
    const isBelowMin = width < SIGNATURE_LIMITS.MIN_WIDTH_PX || height < SIGNATURE_LIMITS.MIN_HEIGHT_PX;
    const isAboveMax = width > SIGNATURE_LIMITS.MAX_WIDTH_PX || height > SIGNATURE_LIMITS.MAX_HEIGHT_PX;
    if (isBelowMin || isAboveMax) return { isValid: false, error: formatDimensionsError() };
    return { isValid: true };
  } catch (err) {
    return { isValid: false, error: err?.message || 'Failed to read image dimensions.' };
  }
};
